import { EXPERIENCE_TYPE } from "../../actions/types";

const initState = {
  successMessage: "",
  errorMessage: "",
};

const editExperience = (state = initState, action) => {
  switch (action.type) {
    case EXPERIENCE_TYPE.EDIT_EXPERIENCE:
      return { ...state, successMessage: action.payload.message };
    case EXPERIENCE_TYPE.EXPERIENCE_ERROR:
      return { ...state, errorMessage: action.payload };
    default:
      return state;
  }
};

export default editExperience;
